import { trackEvent } from 'dibs-tracking';

export const trackSalePdpInteraction = ({
    action,
    isInteractiveEvent = false,
}: {
    action: string;
    isInteractiveEvent?: boolean;
}): void => {
    trackEvent({
        category: 'promo interaction',
        action,
        label: 'sale PDP',
        isInteractiveEvent,
    });
};
